
<div id="w3l-appointment">
  <section class="appointment-section section-gap" >
      <div class="wrapper" >
          <div class="d-grid doctor-appointment"  >
              <div class="appointment-form" style="width:80%;">
                  <form action="#" method="post">
  <div class="styled-input">
    <label>M.R.N</label>
    <div class="appointment-form-field">
        <span class="fa fa-search" style="cursor: grab; width:50px;"  (click)="openDialog()" aria-hidden="true"></span>
        <input type="text" name="PatientCode" placeholder="Patient Code" (change)="RetriveAll()" [(ngModel)]="patientCode" required="" style="width: 15%;"/>
        <span class="fa fa-user" aria-hidden="true"></span>
        <input type="text" name="PatientName" placeholder="Patient Name"  required="" disabled = "true" [(ngModel)]="patientFName" style="width: 45%;">
        <label style="width: 150px;"></label>
        <a href="PatientDocuments" class="drop-text" target="_blank">
        <button type="button" class="theme-button btn fa fa-paperclip" name="delete11" (click)="Attachments()" > Patient Documents/Attachments</button>
        </a>
        <label style="width: 10px;"></label>
        <button type="button" class="theme-button btn fa fa-save" name="delete12" (click)="SubmitAll()"   > Save Patient Medical Record</button>
        <label style="width: 10px;"></label>
        <button type="button" class="theme-button btn fa fa-print" name="delete13"  (click)="PrintAll()"  > Print Patient Medical Record</button>

    </div>
  </div>
  <div class="styled-input">
    <label>Diagnosis</label>
    <br>
        <br>
    <div class="appointment-form-field">
      <span class="fa fa-search-plus" aria-hidden="true" style="height: 200%;cursor: zoom-in;"  (click)="DialogZoom_Diagnosis()" title="Zoom In"></span>
      <textarea rows = "5" cols = "60" name = "Diagnosis" [(ngModel)]= "diagnosis" class="appointment-form-field" style="height: 200%;" > Enter details here... </textarea><br>
    </div>
  </div>
  <div class="styled-input">
    <label>Cancer Type</label>
    <div class="appointment-form-field">
    <span class="fa fa-bars" style="cursor: grab; width:50px;"   aria-hidden="true"  ></span>
    <select id="CanName" name="CanName" [(ngModel)]= "cancerID"  required style="width: 70%;"  >
      <option value="{{Patholo.cancerID}}" *ngFor="let Patholo of cancerList; let i = index">{{Patholo.cancerName}}</option>
    </select>
    <!-- <input type="text" name="cancername" placeholder="Cancer Type"  [(ngModel)]="cancerName_1" required="" style="width: 41%;" disabled ="true" /> -->
    <label style = "width: 4.5%;"></label>
    <label>Age</label>
    <span class="fa fa-search" style="cursor: grab; width:50px;"   aria-hidden="true"></span>
    <input type="number" name="paAge" placeholder="00"  [(ngModel)]="paAge" required="" style="width: 10%;" disabled ="true"/>
    <label style = "width: 4.5%;"></label>
    <label>Pathology</label>
    <span class="fa fa-bookmark" aria-hidden="true"></span>
    <select id="PathologyID" name="PathologyName" [(ngModel)]= "pathology_M"  required>
            <option value="{{Patholo.pathTypeCode}}" *ngFor="let Patholo of PathologyList; let i = index">{{Patholo.pathTypeName}}</option>
    </select>

  </div>

  </div>

<mat-tab-group animationDuration="2000ms" style="width: 1500px;">
  <!----***************Diomgraphic*********************--->
  <mat-tab label="Diomgraphic Data" >Diomgraphic Data

  <BR>
  <BR>
    <div class="styled-input">
      <label>Patient is</label>
      <label style = "width: 35%;"></label>
      <label >Type</label>
      <div class="appointment-form-field">
        <span class="fa fa-calendar" aria-hidden="true"></span>
        <select id="Smoker" name="Smoker" style="width: 35%;background-color:  rgb(187, 203, 238);" [(ngModel)]="smoker" required=""  >
            <option value="No">Not Smoking</option>
            <option value="Yes">Smoking</option>
            <option value="Ex">Ex Smoker</option>
          </select>
          <label style = "width: 2%;" ></label>

          <span class="fa fa-medkit" aria-hidden="true"></span>
          <select id="Pathology1" name="Pathology1" style="width: 27%;background-color:  rgb(187, 203, 238);" [(ngModel)]="smokertype" required>
            <option value="Cigerette">Cigerette</option>
            <option value="Shisha">Shisha</option>
            <option value="Cigar">Cigar</option>
            <option value="Pipe">Pipe</option>
            <option value="Cigerette and shisha">Cigerette and shisha</option>
            <option value="Cigerette and others">Cigerette and others</option>
            <option value="Others">Others</option>
        </select>
      </div>

    <label>Since</label>
    <label>                                              No. of Packs                             Alcohol Intake</label>
    <div class="appointment-form-field">

        <span class="fa fa-sliders" aria-hidden="true"></span>
        <input type="date" name="Since" placeholder="Since" style="width: 14%;background-color:  rgb(187, 203, 238);" required  [(ngModel)]="ssince">

        <label>        </label>
        <span class="fa fa-medkit" aria-hidden="true"></span>
        <input type="text" name="Packs" placeholder="Packs" style="width: 13%;background-color:  rgb(187, 203, 238);" required  [(ngModel)]="nopacks">
        <label>        </label>
        <span class="fa fa-medkit" aria-hidden="true"></span>
        <select id="alcohol" name="alcohol" style="width: 7%;background-color:  rgb(187, 203, 238);" [(ngModel)]="drinkingalcohol" required>
          <option value="No"[selected]="true">No</option>
          <option value="Yes">Yes</option>
      </select>
    </div>
  </div>

  <div class="styled-input">
    <label style="background-color: rgb(47, 47, 176);color: white;font-weight: bold;height: 55px;"> <br> For Female Menstrual  </label>
    <div class="appointment-form-field">
        <label>Menstrual                                        LMP                                          Contraception          Pregnancy at diagnosis</label>
    </div>
    <div class="appointment-form-field">
        <span class="fa fa-sliders" aria-hidden="true"></span>
        <select id="Menstrual" name="Menstrual" style="width: 15%;background-color:  rgb(187, 203, 238);" [(ngModel)]="menstrual" required>
          <option value="NK">NK</option>
          <option value="Peri">Peri</option>
          <option value="Post">Post</option>
          <option value="NA">NA</option>

      </select>
        <label>        </label>
        <span class="fa fa-medkit" aria-hidden="true"></span>
        <input type="date" name="since1" style="width: 13%;background-color:  rgb(187, 203, 238);" required  [(ngModel)]="since">
        <label>      </label>
        <span class="fa fa-medkit" aria-hidden="true"></span>
        <select id="Contraception" name="Contraception" style="width: 6%;background-color:  rgb(187, 203, 238);" [(ngModel)]="contraception" required>
          <option value="NK">NK</option>
          <option value="Injection">Injection</option>
          <option value="IUD">IUD</option>
          <option value="No">No</option>
          <option value="Oral">Oral</option>

      </select>
      <label>         </label>
      <span class="fa fa-sliders" aria-hidden="true"></span>
        <select id="Pregnancy" name="Pregnancy" style="width: 13%;background-color:  rgb(187, 203, 238);" [(ngModel)]="pregnancy" required>
          <option value="NK">NK</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>

      </select>

    </div>

  </div>
  <br>


  <button type="button" class="theme-button btn" name="submit" (click)="submitDemographic()" >Submit</button>
  <button type="button" class="theme-button btn" name="delete" (click)="mesgDeleteDenographic()" >Delete Demographic Data</button>
  </mat-tab>
  <!----************************************************--->
  <!----*********** Medical History*********************--->
  <mat-tab label="Medical History" style="color: rgb(37, 51, 177);font-size: larger;"> Medical History
    <br><br>
    <form action="/action_page.php" >
      <div >
      <div class="appointment-form-field">
          <label   style="width: 15%;height:30px; color: {{MHColor}};font-weight: bold; font-size: larger;font-family: Arial;">• Diabetes</label>
          <label style="color:{{MHColor}}"   >Since     </label>
          <input type="number" name="Sinced" placeholder="0" style="width: 7%;border-width: 0.02cm;padding-top: 0.1cm;" required [(ngModel)]= "diabetessince" >
            <select id="TypeDay" name="Typeday" style="width: 8%;background-color:  rgb(187, 203, 238);" required [(ngModel)]= "diabetesdays">
              <option value="">Select*</option>
              <option value="Day">Day</option>
              <option value="Month">Month</option>
              <option value="Year">Year</option>
            </select>
          <label for="History1" style="width: 17ch;">      Type</label>
          <select id="Typesdibits" name="Typesdibits" style="width: 25%;background-color:  rgb(187, 203, 238);" required [(ngModel)]= "diabetescontrol">
            <option value="">Select*</option>
            <option value="IDDM">IDDM</option>
            <option value="NIDDM">NIDDM</option>

          </select>
      </div>
      </div>
      <div >
      <div class="appointment-form-field">
            <label style="width: 15%;height:30px; color: {{MHColor1}};font-weight: bold; font-size: larger;font-family: Arial;">• Hypertension</label>
            <label style="color:{{MHColor1}}"  >Since     </label>
            <input type="number" name="Sincehy" placeholder="0" style="width: 7%;" required [(ngModel)]= "haypersince">
            <select id="TypehHiber" name="TypehHiber" style="width: 8%; background-color:  rgb(187, 203, 238);" required [(ngModel)]= "hayperdays">
              <option value="">Select*</option>
              <option value="Day">Day</option>
              <option value="Month">Month</option>
              <option value="Year">Year</option>
            </select>

          <label for="History1" style="width: 17ch;">      Illness Control</label>
          <select id="Type1" name="Typeh" style="width: 25%;background-color:  rgb(187, 203, 238);" required [(ngModel)]= "haypercontrol">
            <option value="0">Select*</option>
            <option value="Controlled">Controlled</option>
            <option value="Not Controlled">Not Controlled</option>

        </select>
  </div>
  </div>

      <div >
      <div class="appointment-form-field">
          <label for="History3" style="width: 15%;height:30px;color:  {{MHColor2}};font-weight: bold; font-size: larger;font-family: Arial;">• Hepatites</label>
          <label style="color:  {{MHColor2}}" >Since     </label>

          <input type="number" name="Sinceh" placeholder="0"  style="width: 7%;border-width: 0.02cm;padding-top: 0.1cm;" required [(ngModel)]= "hepasince">
            <select id="Hepatites" name="Hepatites" style="width: 8%;background-color:  rgb(187, 203, 238);" required [(ngModel)]= "hepadays">
              <option value="">Select*</option>
              <option value="Day">Day</option>
              <option value="Month">Month</option>
              <option value="Year">Year</option>
            </select>
        <label for="History1" style="width: 17ch;">      Way of Infection</label>
        <input type="text" name="Since10" placeholder="" style="width: 25%;background-color:  rgb(187, 203, 238);border-width: 0.02cm;" required [(ngModel)]= "hepacontrol" >
      </div>
      </div>

      <div>
        <div class="appointment-form-field">

            <label for="History4" style="width: 15%;height:30px;color:  {{MHColor3}};font-weight: bold; font-size: larger;font-family: Arial;" >• Bilharezia</label>
            <label style="color:  {{MHColor3}}"  >Since     </label>

            <input type="number" name="Sinceb" placeholder="0" style="width: 7%;border-width: 0.02cm;padding-top: 0.1cm;" required [(ngModel)]= "bilhsince">
            <select id="Hepatites2" name="Hepatites2" style="width: 8%;background-color:  rgb(187, 203, 238);" required [(ngModel)]= "bilhdays">
              <option value="">Select*</option>
              <option value="Day">Day</option>
              <option value="Month">Month</option>
              <option value="Year">Year</option>
            </select>

            <label for="History1" style="width: 17ch;">      Type</label>
            <select id="Typesb" name="Typesb" style="width: 25%;background-color:  rgb(187, 203, 238);" required [(ngModel)]= "bilhcontrol">
              <option value="0">Select*</option>
              <option value="Intestinal">Intestinal</option>
              <option value="Urinary">Urinary</option>

        </select>
        </div>
      </div>

      <div >
      <div class="appointment-form-field">
              <label style="width: 15%;height:30px; color: {{MHColor4}};font-weight: bold; font-size: larger;font-family: Arial;">• Cardiac</label>
              <label style="color:  {{MHColor4}}"  >Since     </label>

              <input type="number" name="Sincec" placeholder="0" style="width: 7%;border-width: 0.02cm;padding-top: 0.1cm;" required [(ngModel)]= "cardsince">
              <select id="TypeCardiac" name="TypeCardiac" style="width: 8%;background-color:  rgb(187, 203, 238);" required  [(ngModel)]= "carddays">
                <option value="">Select*</option>
              <option value="Day">Day</option>
              <option value="Month">Month</option>
              <option value="Year">Year</option>
            </select>

            <label for="History1" style="width: 17ch;">      Type</label>
            <select id="CardiacK" name="CardiacK" style="width: 25%;background-color:  rgb(187, 203, 238);" required [(ngModel)]= "cardcontrol">
              <option value="0">Select*</option>
              <option value="Arrhythmia">Arrhythmia</option>
              <option value="cardiomyopathy">cardiomyopathy</option>
              <option value="ischemic">ischemic</option>
              <option value="RHD">RHD</option>


          </select>
      </div>
      </div>

      <div  >
        <div class="appointment-form-field">
            <label style="width: 15%;height:30px; color: {{MHColor5}};font-weight: bold; font-size: larger;font-family: Arial;">• Auto immune</label>
            <label style="color: {{MHColor5}}"  >Since     </label>
            <input type="number" name="Sincea" placeholder="0" style="width: 7%;border-width: 0.02cm;padding-top: 0.08cm;" required [(ngModel)]= "autosince">
            <select id="TypeAuto" name="TypeAuto" style="width: 8%;background-color:  rgb(187, 203, 238);" required [(ngModel)]= "autodays">
              <option value="0">Select*</option>
              <option value="Day">Day</option>
              <option value="Month">Month</option>
              <option value="Year">Year</option>
          </select>
          <label for="History1" style="width: 17ch;">      Type</label>
          <input type="text" name="Sinceau" placeholder="" style="width: 25%;background-color:  rgb(187, 203, 238);border-width: 0.02cm;" required [(ngModel)]= "autocontrol" >
        </div>
      </div>


      <div >
      <div class="appointment-form-field">
          <label style="width: 15%;height:30px; color: {{MHColor6}};font-weight: bold; font-size: larger;font-family: Arial;">• Allergy</label>
          <label style="color: {{MHColor6}}" >Since     </label>

          <input type="number" name="Sinceal" placeholder="0" style="width: 7%;border-width: 0.02cm;padding-top: 0.08cm;" required [(ngModel)]= "allergysince">
          <select id="TypeAuto1" name="TypeAuto1" style="width: 8%;background-color:  rgb(187, 203, 238);" required [(ngModel)]= "allergydays">
            <option value="0">Select*</option>
            <option value="Day">Day</option>
            <option value="Month">Month</option>
            <option value="Year">Year</option>
        </select>

        <label for="History1" style="width: 17ch;">      Type</label>
        <input type="text" name="typeall" placeholder="" style="width: 25%;background-color:  rgb(187, 203, 238);border-width: 0.02cm;" required [(ngModel)]= "allergycontrol" >
      </div>
      </div>

    <div >
      <div class="appointment-form-field">
            <label style="width: 15%;height:30px; color: {{MHColor7}};font-weight: bold; font-size: larger;font-family: Arial;">• Others</label>
            <label style ="color: {{MHColor7}}"  >Since     </label>

            <input type="number" name="Since88" placeholder="0" style="width: 7%;border-width: 0.02cm;padding-top: 0.079cm;" required [(ngModel)]= "otherssince" >

            <select id="TypeOthers1" name="TypeOthers1" style="width: 8%;background-color:  rgb(187, 203, 238);" required [(ngModel)]= "othersdays">
              <option value="0">Select*</option>
              <option value="1">Day</option>
              <option value="2">Month</option>
              <option value="3">Year</option>
          </select>
          <label for="History1" style="width: 17ch;">      Type</label>
          <input type="text" name="Since19" placeholder="" style="width: 25%;background-color:  rgb(187, 203, 238);border-width: 0.02cm;" required [(ngModel)]= "otherscontrol">

      </div>
    </div>


      <br>
      <button type="button" class="theme-button btn" name="submit" (click)="submitMedicalHistory()">Submit</button>
      <button type="button" class="theme-button btn" name="delete" (click)="DeleteMedicalHistory()">Delete Medical History</button>

    </form>
  </mat-tab>

  <!----****************Surgical/Family History****************--->
  <mat-tab label="Surgical/Family History">
    <br>
    <div class="appointment-form-field" style = "text-align: center;">
    <label style="width: 800px;padding-top: 0.5%; height: 30px; color: white;background-color: gray; font-size: larger;font-family: Arial;">Non Cancer Sergical History</label>
    </div>
    <table style="width: 800px;">
      <thead>
          <tr>
              <th style="background-color:  rgb(70, 70, 247);color: white;width: 15%;height: 5%;">Surgery Date</th>
              <th style="background-color:  rgb(70, 70, 247);color: white;width: 25%;height: 30%;">Opration's Name</th>
              <th style="background-color:  rgb(70, 70, 247);color: white; width: 15%;height: 8%;">Surgery Doctor</th>
              <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;height: 8%;">Select</th>

          </tr>
      </thead>
      <tbody>

        <tr *ngFor="let pro of surgeryhistory; let i = index" style="height: 50%;">
          <td data-column="Patient ID" style="height: 5%;">{{pro.date}}</td>
          <td data-column="Patient Name"style="height: 30%;">{{pro.operationsname}}</td>
          <td data-column="Patient Name"style="height: 10%;">{{pro.surgicaldoctor}}</td>
          <button name="BDrug" placeholder = "0" style="width: 100%;height: 35px;" required (click)="SelectSurgical(pro)">Select</button>
        </tr>
      </tbody>
    </table>
    <div class="styled-input">
      <div class="appointment-form-field">
        <input type="date" name="SurgDate"  required="" style="width: 15%;" [(ngModel)]= "date"/>
        <input type="textarea" name="CommentOperation" placeholder="Operation's Name" [(ngModel)]= "operationsname" required="" style="width: 26%;"/>
        <input type="textarea" name="DoctorOperation" placeholder="Operation's Doctor" [(ngModel)]= "surgicaldoctor" required="" style="width: 15.5%;"/>
        <button name="BDrug" placeholder = "0" style="width: 5%;height: 100%;" required (click)="submitSHistory()">Submit</button>
        <label style="width:.5%"></label>
        <button name="BDrug1" placeholder = "0" style="width: 5%;height: 100%;" required (click)="delSHistory_Line()">Delete</button>
      </div>
    </div>
<br>
<div class="appointment-form-field" style = "text-align: center;">
<label for="History1"   style="width: 800px;padding-top: 0.5%; height: 30px;color: white;background-color: gray; font-size: larger;font-family: Arial;">  Family History</label>
</div>
<table style="width: 800px;">
  <thead>
      <tr>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 15%;height: 5%;">Relation</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 25%;height: 30%;">Cancer Type</th>
          <th style="background-color:  rgb(70, 70, 247);color: white; width: 15%;height: 8%;">Age st Diagnosis</th>
          <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;height: 8%;">Select</th>

      </tr>
  </thead>
  <tbody>

    <tr *ngFor="let fam of familyhistory; let i = index" style="height: 50%;">
      <td data-column="Patient ID" style="height: 5%;">{{fam.relation}}</td>
      <td data-column="Patient Name"style="height: 30%;">{{fam.cancername}}</td>
      <td data-column="Patient Name"style="height: 10%;">{{fam.age}}</td>
      <button name="BDrug" placeholder = "0" style="width: 100%;height: 35px;" required (click)="SelectFamily(fam)">Select</button>
    </tr>
  </tbody>
</table>
<div class="styled-input">
    <div class="appointment-form-field">
      <select id="relation" name="relation" style="width: 15.5%;background-color:  rgb(187, 203, 238);" [(ngModel)]= "relation" required>
        <option value="Mother">Mother</option>
        <option value="Father">Father</option>
        <option value="Brother">Brother</option>
        <option value="Sister">Sister</option>
        <option value="Daughter">Daughter</option>
        <option value="Son">Son</option>
        <option value="Aunt">Aunt</option>
        <option value="Uncle">Uncle</option>
        <option value="Cousin">Cousin</option>
        <option value="Niece">Niece</option>
        <option value="Grandmather">Grandmather</option>

    </select>
      <select id="itemsgroup" name="itemsgroup" required=""  style="width: 25.5%;background-color: white;" [(ngModel)]= "cancerID" [value]="cancerName">
        <option value="{{itm.cancerID}}"  *ngFor="let itm of cancerList; let i = index">{{itm.cancerName}}</option>
      </select>
      <input type="textarea" name="DoctorOperation" placeholder="0" [(ngModel)]= "age" required="" style="width: 15%;"/>
      <button name="BDrug_0" placeholder = "0" style="width: 5%;height: 100%;" required (click)="submitFHistory()">Submit</button>
      <label style="width:.5%"></label>
      <button name="BDrug_1" placeholder = "0" style="width: 5%;height: 100%;" required (click)="delFHistory_Line()">Delete</button>
    </div>
</div>

</mat-tab>

<!----****************Current Medication **********************--->

  <!----*********** Investigation *********************--->
  <mat-tab label="Investigations">Investigation
    <div class="appointment-form-field">
      <label for="History1" style="text-align: center;padding-top: 0.5%; height: 35px;background-color:  gray;color: aliceblue;font-size: larger;font-style: initial; width: 1100px;" >Pathology</label>
  </div>

  <table style="font-size:smaller;" >
    <thead>
        <tr>
            <th style="background-color:  rgb(70, 70, 247);color: white;width: 15%;height: 5%;">Date</th>
            <th style="background-color:  rgb(70, 70, 247);color: white;width: 17%;height: 25%;">Pathologist</th>
            <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;height: 8%;">Type of biopsy</th>
            <th style="background-color:  rgb(70, 70, 247);color: white; width: 15%;height: 8%;">Site</th>
            <th style="background-color:  rgb(70, 70, 247);color: white; width: 13%;height: 8%;">Histopathological Type</th>
            <th style="background-color:  rgb(70, 70, 247);color: white; width: 6%;height: 8%;">Grade</th>
            <th style="background-color:  rgb(70, 70, 247);color: white; width: 4%;height: 8%;">T</th>
            <th style="background-color:  rgb(70, 70, 247);color: white; width: 4%;height: 8%;">N</th>
            <th style="background-color:  rgb(70, 70, 247);color: white; width: 4%;height: 8%;">M</th>
            <th style="background-color:  rgb(70, 70, 247);color: white; width: 14%;height: 8%;">Select</th>

        </tr>
    </thead>
    <tbody>

      <tr *ngFor="let path of pathology; let i = index" style="height: 50%;font-size: small;">
        <td data-column="Patient ID" style="height: 5%;">{{path.pdate}}</td>
        <td data-column="Patient Name"style="height: 30%;">{{path.pathinvpathology}}</td>
        <td data-column="Patient Name"style="height: 10%;">{{path.pathinvtype}}</td>
        <td data-column="Patient Name"style="height: 10%;">{{path.pathinvsite}}</td>
        <td data-column="Patient Name"style="height: 10%;">{{path.pathinvhtype}}</td>
        <td data-column="Patient Name"style="height: 10%;">{{path.pagrade}}</td>
        <td data-column="Patient Name"style="height: 10%;">{{path.pat}}</td>
        <td data-column="Patient Name"style="height: 10%;">{{path.pan}}</td>
        <td data-column="Patient Name"style="height: 10%;">{{path.pathihc}}</td>
        <button name="BDrug" placeholder = "0" style="width: 100%;height: 35px;" required (click)="SelectPathology(path)">Select</button>
      </tr>
    </tbody>
  </table>
  <div class="styled-input">
      <div class="appointment-form-field">
      <input type="date" name="PatDate" placeholder="0" required="" style="width: 13.5%;" [(ngModel)]= "pdate"/>
      <input type="text" name="patholgist" placeholder="Pathologist" required="" style="width: 15.3%;" [(ngModel)]= "pathinvpathology"/>

      <select id="bioType" name="bioType" placeholder="Select" required="" style="width: 9%;background-color: white;" [(ngModel)]="pathinvtype" [value]="pathinvtype">
        <option value="" selected>Select *</option>
        <option value="FNA">FNA</option>
        <option value="Excision">Excision</option>
        <option value="Biopsy">Biopsy</option>
        <option value="Surgical specimen">Surgical specimen</option>
      </select>

        <input type="textarea" name="histype" placeholder="site" [(ngModel)]= "pathinvsite" required="" style="width: 13.5%;"/>
        <select id="histype2" name="histype2" required="" style="width: 11.6%;background-color: white;" [(ngModel)]="pathinvhtype" [value]="pathinvhtype">
          <option value="Squamous">Squamous</option>
          <option value="Adenocarcinoma">Adenocarcinoma</option>
          <option value="Others">Others</option>
        </select>

        <select id="grade" name="grade" required="" style="width: 5.5%;background-color: white;" [(ngModel)]="pagrade" [value]="pagrade">
          <option value="I">I</option>
          <option value="II">II</option>
          <option value="III">III</option>
          <option value="NK">NK</option>
        </select>

        <select id="t" name="t" required="" style="width: 3.6%;background-color: white;" [(ngModel)]="pat" [value]="pat">
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="TX">TX</option>
        </select>
        <select id="n" name="n" required="" style="width: 3.6%;background-color: white;" [(ngModel)]="pan" [value]="pan">
          <option value="0">0</option>
          <option value="1">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="TX">TX</option>
        </select>
        <select id="m" name="m" required="" style="width: 3.6%;background-color: white;" [(ngModel)]="pathihc" [value]="pathihc">
          <option value="0">0</option>
          <option value="1">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="TX">TX</option>
        </select>

        <button name="BDrug" placeholder = "0" style="width: 5.5%;height: 90%;" required (click)="submitPathology()">Submit</button>
        <label style="width:1%"></label>
        <button name="BDrug1" placeholder = "0" style="width: 5.5%;height: 90%;" required (click)="delPathology_Line()">Delete</button>
      </div>
  </div>

      <div class="appointment-form-field">
        <label>Comment             </label>
          <textarea rows="5" cols="60" name="description" class="appointment-form-field"
              style="height: 200%;width: 80%;"  [(ngModel)]="pathinvcomment" maxlength="150ch" placeholder="Enter details here... " > </textarea><br>
      </div>
      <BR>
      <BR>
      <BR>
      <BR>
      <div class="appointment-form-field">
          <label for="History1" style="text-align: center;padding-top: 0.5%; height: 35px;background-color:  gray;color: aliceblue;font-size: larger;font-style: initial; width: 1000px;" >Imaging</label>
     </div>
     <table style="font-size: small;width: 1000px;">
      <thead>
          <tr>
              <th style="background-color:  rgb(70, 70, 247);color: white;width: 15%;height: 7%;">Date</th>
              <th style="background-color:  rgb(70, 70, 247);color: white;width: 18%;height: 25%;">Type of Imaging</th>
              <th style="background-color:  rgb(70, 70, 247);color: white;width: 18%;height: 25%;">Image Center</th>
              <th style="background-color:  rgb(70, 70, 247);color: white; width: 30%;height: 8%;">Comment</th>
              <th style="background-color:  rgb(70, 70, 247);color: white; width: 15%;height: 8%;">Select</th>

          </tr>
      </thead>
      <tbody>

        <tr *ngFor="let cur of images; let i = index" style="height: 50%;">
          <td data-column="Patient ID" style="height: 5%;">{{cur.imginvdate}}</td>
          <td data-column="Patient Name"style="height: 30%;">{{cur.imginvtype}}</td>
          <td data-column="Patient Name"style="height: 30%;">{{cur.imginv}}</td>
          <td data-column="Patient Name"style="height: 10%;">{{cur.imginvcomm}}</td>
          <button name="BDrug" placeholder = "0" style="width: 100%;height: 35px;" required (click)="SelectImages(cur)">Select</button>
        </tr>
      </tbody>
    </table>
    <div class="styled-input">
        <div class="appointment-form-field">
        <input type="date" name="imgDate" placeholder="0" required="" style="width: 13%;" [(ngModel)]="imginvdate"/>
        <select id="imgtype" name="imgtype" required="" style="width: 15.5%;background-color: white;" [(ngModel)]="imginvtype" [value]="imginvtype">
          <option value="{{img.imagename}}" *ngFor="let img of imagestype; let i = index">{{img.imagename}}</option>
        </select>
        <input type="text" name="imginv" placeholder="Image Center" required="" style="width: 15.5%;" [(ngModel)]="imginv"/>

          <input type="textarea" name="imgCommint" placeholder="Comments" [(ngModel)]= "imginvcomm" required="" style="width: 26.2%;"/>
          <button name="BDrug" placeholder = "0" style="width: 6%;height: 100%;" required (click)="submitImages()">Submit</button>
          <label style="width:1%"></label>
          <button name="BDrug1" placeholder = "0" style="width: 6%;height: 100%;" required (click)="delImagesLine()">Delete</button>
        </div>
    </div>

    <BR>
    <BR>

  <div class="appointment-form-field">
      <label for="History1" style="text-align: center;padding-top: 0.5%; height: 35px;background-color:  gray;color: aliceblue;font-size: larger;font-style: initial; width: 800px;" >Endoscopy</label>
  </div>
 <table style="font-size: small;width: 800px;">
  <thead>
      <tr>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 15.2%;height: 5%;">Date</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 18%;height: 25%;">Type of Endoscopy</th>
          <th style="background-color:  rgb(70, 70, 247);color: white; width: 30%;height: 8%;">Comment</th>
          <th style="background-color:  rgb(70, 70, 247);color: white; width: 15%;height: 8%;">Select</th>

      </tr>
  </thead>
  <tbody>

    <tr *ngFor="let cur of endoscopy; let i = index" style="height: 50%;">
      <td data-column="Patient ID" style="height: 5%;">{{cur.endoinvdate}}</td>
      <td data-column="Patient Name"style="height: 30%;">{{cur.endoinvtype}}</td>
      <td data-column="Patient Name"style="height: 30%;">{{cur.endoinvcomm}}</td>
      <button name="BDrug" placeholder = "0" style="width: 100%;height: 35px;" required (click)="SelectEndoscopy(cur)">Select</button>
    </tr>
  </tbody>
</table>
<div class="styled-input">
    <div class="appointment-form-field">
    <input type="date" name="endoDate" placeholder="0" required="" style="width: 13%;" [(ngModel)]="endoinvdate" />
    <select id="endotype" name="endotype" required="" style="width: 15.5%;background-color: white;" [(ngModel)]="endoinvtype" [value]="uom">
      <option value="{{endo.endotypename}}" *ngFor="let endo of endotype; let i = index">{{endo.endotypename}}</option>
    </select>

      <input type="textarea" name="endoCommint" placeholder="Comments" [(ngModel)]= "endoinvcomm" required="" style="width: 25%;"/>

      <button name="BDrug" placeholder = "0" style="width: 6%;height: 100%;" required (click)="submitEndoscopy()">Submit</button>
      <label style="width:1%"></label>
      <button name="BDrug1" placeholder = "0" style="width: 6%;height: 100%;" required (click)="delEndoscopyLine()">Delete</button>
    </div>
</div>


   </mat-tab>

<!----********** General Examination ******************--->
<mat-tab label="General Examination">
  <BR>
  <div class="appointment-form-field" >
    <label style="width: 100px;height: 50px;padding-top: 15px;" >Date  </label>
    <input type="date" name="GExDate" placeholder="0" required="" style="width: 13%;" [(ngModel)]="examdate"/>

  </div>
  <BR>
  <div >
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;background-color:  gray;color: aliceblue;font-size: 20px;font-style: normal; width: 300px;">General Condition                   </label>
    <label>       </label>
    <input type="radio" name="GC1" value="Good" style="width: 20px;text-align: left;" [(ngModel)]="gcondition" >Good
    <label>       </label>
    <input type="radio" name="GC1"  value="Moderate" style="width: 20px;text-align: left;" [(ngModel)]="gcondition" >Moderate
    <label>       </label>
    <input type="radio" name="GC1" value="Cachectic"  style="width: 20px;text-align: left;" [(ngModel)]="gcondition" >Cachectic
    <label>       </label>
    <input type="radio" name="GC1"  value="Toxic" style="width: 20px;text-align: left;" [(ngModel)]="gcondition" >Toxic

  </div>
 <BR>
  <div >
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;background-color:  gray;color: aliceblue;font-size: 20px;font-style: normal; width: 300px;">Performance Status               </label>
    <label>       </label>
    <input type="radio" name="PS1" value="0" style="width: 20px;text-align: left;" [(ngModel)]="peform" >0
    <label>       </label>
    <input type="radio" name="PS1"  value="I" style="width: 20px;text-align: left;" [(ngModel)]="peform">I
    <label>       </label>
    <input type="radio" name="PS1" value="II"  style="width: 20px;text-align: left;" [(ngModel)]="peform">II
    <label>       </label>
    <input type="radio" name="PS1"  value="III" style="width: 20px;text-align: left;" [(ngModel)]="peform">III
    <label>       </label>
    <input type="radio" name="PS1"  value="IV" style="width: 20px;text-align: left;" [(ngModel)]="peform">IV

  </div>
<BR>
  <hr>
  <div class="styled-input">
        <label>Weight K.G  </label>
        <input type="number"  name="GExweight" placeholder="0" style="width: 10%;height: 35px; background-color:  rgb(187, 203, 238);" required   [(ngModel)]="weight">

        <label>           </label>
        <label>Height C.M.  </label>
        <input type="number"   name="GExHeight" placeholder="0" style="width: 10%;height: 35px;background-color:  rgb(187, 203, 238);" required   [(ngModel)]="height">
        <label>           </label>
        <label>SA M²  </label>
        <input type="number"  name="GExSa" placeholder="0" style="width: 10%;height: 35px;background-color:  rgb(187, 203, 238);" required [(ngModel)]="s_a"  >
    </div>
  <hr>

      <div >
        <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;background-color:  gray;color: aliceblue;font-size: 20px;font-style: normal; width: 300px;">Vital Signs                                 </label>
        <label>           </label>
        <label>Temp   C°   </label>
        <input type="number"  name="GExTemp" placeholder="0" style="width: 10%;height: 35px;" max="43" min="33" required  [(ngModel)]="temp"  >

        <label>           </label>
        <label>Pulse p/m  </label>
        <input type="text"   name="GExPuls" placeholder="0" style="width: 10%;height: 35px;" required [(ngModel)]="pulse"  >
        <label>           </label>
        <label>B.P.     </label>
        <input type="text"  name="GExbp"  style="width: 10%;height: 35px;" required  [(ngModel)]="b_p"  >
        <label>           </label>
        <label>Respiration Rate  </label>
        <input type="number"  name="GExRate" placeholder="0" style="width: 10%;height: 35px;" required   [(ngModel)]="respirationrate">

      </div>
      <div>
        <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                                 Rhythm </label>
        <label>       </label>
        <input type="radio" name="Rh1" value="Regular" style="width: 20px;text-align: left;" [(ngModel)]="rhythm">Regular
        <label>       </label>
        <input type="radio" name="Rh1"  value="Irregular" style="width: 20px;text-align: left;" [(ngModel)]="rhythm">Irregular
      </div>

      <hr>
      <BR>
       <!------********* Head & Neck ***************-->
        <div >
          <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;background-color:  gray;color: aliceblue;font-size: 20px;font-style: normal; width: 300px;">Head & Neck                             </label>
          <label style ="width: 50px;">                               </label>
          <input type="radio" name="H_N" value="Normal" style="width: 20px;text-align: left;" [(ngModel)]="headneck">Normal
          <label>       </label>
          <input type="radio" name="H_N"  value="Abnormal" style="width: 20px;text-align: left;"  [(ngModel)]="headneck">Abnormal
       </div>
       <div>
        <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                             Color </label>
        <label>                </label>
        <input type="radio" name="color" value="Normal" style="width: 20px;text-align: left;"  [(ngModel)]="hncolour">Normal
        <label>       </label>
        <input type="radio" name="color"  value="Cyanosis" style="width: 20px;text-align: left;"  [(ngModel)]="hncolour">Cyanosis
        <label>       </label>
        <input type="radio" name="color"  value="Pallor" style="width: 20px;text-align: left;" [(ngModel)]="hncolour">Pallor
        <label>       </label>
        <input type="radio" name="color"  value="Jaundice" style="width: 20px;text-align: left;" [(ngModel)]="hncolour">Jaundice
        <label>       </label>
        <input type="radio" name="color"  value="Pigmentaion" style="width: 20px;text-align: left;" [(ngModel)]="hncolour">Pigmentaion

      </div>
      <div>
        <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                   Neck veins </label>
        <label>                </label>
        <input type="radio" name="hnveins" value="Normal" style="width: 20px;text-align: left;" [(ngModel)]="hnveins">Normal
        <label>       </label>
        <input type="radio" name="hnveins"  value="Congested" style="width: 20px;text-align: left;" [(ngModel)]="hnveins">Congested
        <label>     </label>
        <input type="radio" name="hnveins"  value="Collapsed" style="width: 20px;text-align: left;" [(ngModel)]="hnveins">Collapsed

      </div>

      <div>
        <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                         Thyroid     </label>
        <label>            </label>
        <input type="radio" name="thy" value="Normal" style="width: 20px;text-align: left;" [(ngModel)]="hnthyroid">Normal
        <label>       </label>
        <input type="radio" name="thy"  value="Enlargement" style="width: 20px;text-align: left;" [(ngModel)]="hnthyroid">Enlargement

      </div>
      <div>
        <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                     Oral cavity    </label>
        <label>            </label>
        <input type="radio" name="or" value="Normal" style="width: 20px;text-align: left;" [(ngModel)]="hnoralcavity">Normal
        <label>       </label>
        <input type="radio" name="or"  value="abnormal" style="width: 20px;text-align: left;" [(ngModel)]="hnoralcavity">Abnormal
        <label>          </label>
        <label>Mention  </label>
        <input type="text"  name="GExMension" placeholder=" " style="width: 15%;height: 30px;" required [(ngModel)]="hnmention"  >
      </div>
      <div>

        <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                         Swelling </label>
        <label>                 Site </label>
        <input type="text"  name="GExSite1" placeholder=" " style="width: 12.9%;height: 30px;" required  [(ngModel)]="hnswellingsite"  >
        <label>             </label>
        <label>Size      </label>
        <input type="text"  name="GExSize1" placeholder=" " style="width: 15%;height: 30px;" required  [(ngModel)]="hnswellingsize" >
      </div>
      <div>
        <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                   Consistency    </label>
        <label>           </label>
        <input type="radio" name="Con" value="Soft" style="width: 20px;text-align: left;" [(ngModel)]="hncons" >Soft
        <label>            </label>
        <input type="radio" name="Con"  value="Firm" style="width: 20px;text-align: left;"  [(ngModel)]="hncons">Firm
        <label>              </label>
        <input type="radio" name="Con"  value="Hard" style="width: 20px;text-align: left;"  [(ngModel)]="hncons">Hard
      </div>
      <div>
        <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                         Mobility    </label>
        <label>            </label>
        <input type="radio" name="mob" value="Fixed" style="width: 20px;text-align: left;"  [(ngModel)]="hnmob">Fixed
        <label>          </label>
        <input type="radio" name="mob"  value="Firm" style="width: 20px;text-align: left;"  [(ngModel)]="hnmob">Mobile
      </div>
<hr>
<BR>
    <!------********* Upper & Limbs ***************-->
  <div >
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;background-color:  gray;color: aliceblue;font-size: 20px;font-style: normal; width: 300px;">Upper & Limbs                          </label>
    <label>                               </label>
    <input type="radio" name="upL" value="Normal" style="width: 20px;text-align: left;"  [(ngModel)]="upperlimbs" >Normal
    <label>       </label>
    <input type="radio" name="uPL"  value="Abnormal" style="width: 20px;text-align: left;" [(ngModel)]="upperlimbs">Abnormal
  </div>
  <div>
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal;font-weight: bold; width: 200px;padding-left: 150px;">Right</label>
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                        Swelling </label>
    <label>                 Site </label>
    <input type="text"  name="GExSite2" placeholder=" " style="width: 12.9%;height: 30px;" required  [(ngModel)]="ulrswellsite" >
    <label>               </label>
    <label>Size  </label>
    <input type="text"  name="GExSizew" placeholder=" " style="width: 15%;height: 30px;" required  [(ngModel)]="ulrswellsize" >
  </div>
  <div>
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                   Consistency </label>
    <label>              </label>
    <input type="radio" name="Con0" value="Soft" style="width: 20px;text-align: left;" [(ngModel)]="ulrcon" >Soft
    <label>             </label>
    <input type="radio" name="Con0"  value="Firm" style="width: 20px;text-align: left;" [(ngModel)]="ulrcon">Firm
    <label>            </label>
    <input type="radio" name="Con0"  value="Hard" style="width: 20px;text-align: left;" [(ngModel)]="ulrcon">Hard
  </div>
  <div>
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                          Oedema</label>
    <label>               </label>
    <input type="checkbox" name="oed1" value="True" style="width: 20px;text-align: left;" [(ngModel)]="ulroedema">
    <label>    </label>
    <label>Others  </label>
    <input type="text"  name="GExOthers" placeholder=" " style="width: 32%;height: 30px;" required [(ngModel)]="ulrothers"  >
  </div>
<BR>
  <div>
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal;font-weight: bold; width: 200px;padding-left: 150px;">Left  </label>
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                        Swelling </label>
    <label>                   Site </label>
    <input type="text"  name="GExSite3" placeholder=" " style="width: 12.9%;height: 30px;" required [(ngModel)]="ullswellsite"    >
    <label>             </label>
    <label>Size  </label>
    <input type="text"  name="GExSize3" placeholder=" " style="width: 15.2%;height: 30px;" required    [(ngModel)]="ullswellsize" >
  </div>
  <div>
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                   Consistency </label>
    <label>                </label>
    <input type="radio" name="Con1" value="Soft" style="width: 20px;text-align: left;"  [(ngModel)]="ullcon" >Soft
    <label>         </label>
    <input type="radio" name="Con1"  value="Firm" style="width: 20px;text-align: left;" [(ngModel)]="ullcon" >Firm
    <label>           </label>
    <input type="radio" name="Con1"  value="Hard" style="width: 20px;text-align: left;" [(ngModel)]="ullcon" >Hard
  </div>
  <div>
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                          Oedema</label>
    <label>                 </label>
    <input type="checkbox" name="oed1" value="Soft" style="width: 20px;text-align: left;" [(ngModel)]="ulloedema" >
    <label>     </label>
    <label>Others  </label>
    <input type="text"  name="GExOthers2" placeholder=" " style="width: 32%;height: 30px;" required  [(ngModel)]="ullothers" >
  </div>
<br>
<hr>
<BR>
  <!------********* Lower & Limbs ***************-->
  <div >
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;background-color:  gray;color: aliceblue;font-size: 20px;font-style: normal; width: 300px;">Lower & Limbs                          </label>
    <label>                                 </label>
    <input type="radio" name="LoL" value="Normal" style="width: 20px;text-align: left;" [(ngModel)]="lowerlimbs">Normal
    <label>       </label>
    <input type="radio" name="LoL"  value="Abnormal" style="width: 20px;text-align: left;" [(ngModel)]="lowerlimbs">Abnormal
  </div>
  <div>
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal;font-weight: bold; width: 200px;padding-left: 150px;">Right</label>
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                        Swelling </label>
    <label>                   Site </label>
    <input type="text"  name="LolSite" placeholder=" " style="width: 12.9%;height: 30px;" required  [(ngModel)]="llrswellsite" >
    <label>               </label>
    <label>Size  </label>
    <input type="text"  name="GExSize4" placeholder=" " style="width: 14.9%;height: 30px;" required  [(ngModel)]="llrswellsize" >
  </div>
  <div>
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                   Consistency </label>
    <label>                 </label>
    <input type="radio" name="Con2" value="Soft" style="width: 20px;text-align: left;" [(ngModel)]="llrcon">Soft
    <label>             </label>
    <input type="radio" name="Con2"  value="Firm" style="width: 20px;text-align: left;" [(ngModel)]="llrcon">Firm
    <label>             </label>
    <input type="radio" name="Con2"  value="Hard" style="width: 20px;text-align: left;" [(ngModel)]="llrcon">Hard
  </div>
  <div>
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                          Oedema</label>
    <label>                  </label>
    <input type="checkbox" name="oed2" value="Soft" style="width: 20px;text-align: left;" [(ngModel)]="llroedema">
    <label>     </label>
    <label>Others  </label>
    <input type="text"  name="GExOthers3" placeholder=" " style="width: 32%;height: 30px;" required [(ngModel)]="llrothers"  >
  </div>
<BR>
  <div>
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal;font-weight: bold; width: 200px;padding-left: 150px;">Left  </label>
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                         Swelling </label>
    <label>                   Site </label>
    <input type="text"  name="LolSite5" placeholder=" " style="width: 12.9%;height: 30px;" required [(ngModel)]="lllswellsite"   >
    <label>               </label>
    <label>Size  </label>
    <input type="text"  name="LolSize5" placeholder=" " style="width: 15%;height: 30px;" required   [(ngModel)]="lllswellsize" >
  </div>
  <div>
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                   Consistency </label>
    <label>                  </label>
    <input type="radio" name="Con3" value="Soft" style="width: 20px;text-align: left;"  [(ngModel)]="lllcon" >Soft
    <label>             </label>
    <input type="radio" name="Con3"  value="Firm" style="width: 20px;text-align: left;" [(ngModel)]="lllcon" >Firm
    <label>             </label>
    <input type="radio" name="Con3"  value="Hard" style="width: 20px;text-align: left;" [(ngModel)]="lllcon" >Hard
  </div>
  <div>
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                          Oedema</label>
    <label>                   </label>
    <input type="checkbox" name="oed2" value="Soft" style="width: 20px;text-align: left;" [(ngModel)]="llloedema" >
    <label>     </label>
    <label>Others  </label>
    <input type="text"  name="GExOthers6" placeholder=" " style="width: 32%;height: 30px;" required  [(ngModel)]="lllothers"  >
  </div>
<br>
<hr>
<br>
<!------********* Breast***************-->
<div >
  <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;background-color:  gray;color: aliceblue;font-size: 20px;font-style: normal; width: 300px;">Breast                                           </label>
  <label>                              </label>
  <input type="radio" name="Br1" value="Normal" style="width: 20px;text-align: left;" [(ngModel)]="brest">Normal
  <label>       </label>
  <input type="radio" name="Br1"  value="Abnormal" style="width: 20px;text-align: left;" [(ngModel)]="brest">Abnormal

</div>
<div>
  <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                                    Right </label>
  <label>            </label>
  <input type="radio" name="righ" value="Normal" style="width: 20px;text-align: left;" [(ngModel)]="bright">Normal
  <label>       </label>
  <input type="radio" name="righ"  value="Abnormal Benign" style="width: 20px;text-align: left;" [(ngModel)]="bright">Abnormal Benign
  <label>       </label>
  <input type="radio" name="righ"  value="Abnormal Malignant" style="width: 20px;text-align: left;" [(ngModel)]="bright">Abnormal Malignant
  <label>       </label>
</div>

<div>
  <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                                   Left  </label>
  <label>              </label>
  <input type="radio" name="Lft" value="Normal" style="width: 20px;text-align: left;" [(ngModel)]="bleft">Normal
  <label>       </label>
  <input type="radio" name="Lft"  value="Abnormal Benign" style="width: 20px;text-align: left;" [(ngModel)]="bleft">Abnormal Benign
  <label>       </label>
  <input type="radio" name="Lft"  value="Abnormal Malignant" style="width: 20px;text-align: left;" [(ngModel)]="bleft">Abnormal Malignant
</div>
<hr>
<br>
<!------********* Chest ***************-->
<div >
  <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;background-color:  gray;color: aliceblue;font-size: 20px;font-style: normal; width: 300px;">Chest                                           </label>
  <label>                              </label>
  <input type="radio" name="ch1" value="Normal" style="width: 20px;text-align: left;" [(ngModel)]="chest">Normal
  <label>       </label>
  <input type="radio" name="ch1"  value="Abnormal" style="width: 20px;text-align: left;" [(ngModel)]="chest">Abnormal
  <label>       </label>
  <label>Specify  </label>
    <input type="text"  name="LolSize" placeholder=" " style="width: 25%;height: 30px;" required  [(ngModel)]="chestspes" >

</div>
<hr>
<br>
<!------********* Abdomen ***************-->
<div >
  <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;background-color:  gray;color: aliceblue;font-size: 20px;font-style: normal; width: 300px;">Abdomen                                    </label>
  <label>                               </label>
  <input type="radio" name="abd" value="Normal" style="width: 20px;text-align: left;"  [(ngModel)]="abdomen">Normal
  <label>       </label>
  <input type="radio" name="abd"  value="Abnormal" style="width: 20px;text-align: left;"  [(ngModel)]="abdomen">Abnormal
</div>
<div>
  <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                               Liver  (cm)  </label>
  <label style ="padding-left: 2px;">             </label>
   <input type="text"  name="LolSize" placeholder=" "  style="width: 15%;height: 30px; " required  [(ngModel)]="abdliver"  >
</div>
<div>
  <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                             Spleen (cm)  </label>
  <label >             </label>
   <input type="text"  name="LolSize" placeholder=" "  style="width: 15%;height: 30px; " required   [(ngModel)]="abdspleen" >
</div>
<div>
  <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                                   Ascities </label>
  <label>         </label>
  <input type="radio" name="asc" value="Moderate" style="width: 20px;text-align: left;"  [(ngModel)]="abdascities" >Moderate
  <label>     </label>
  <input type="radio" name="asc"  value="Massive" style="width: 20px;text-align: left;"  [(ngModel)]="abdascities">Massive
  <div>
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-style: normal; width: 300px;">                                                                                     Others </label>
    <label>              </label>
     <input type="text"  name="LolSize" placeholder=" " style="width: 45%;height: 30px;" required [(ngModel)]="abdothers"  >
  </div>
</div>
  <BR>
  <hr>
<!------********* Neurological ***************-->
<div >
  <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;background-color:  gray;color: aliceblue;font-size: 20px;font-style: normal; width: 300px;">Neurological                               </label>
  <label>                              </label>
  <input type="radio" name="Neur" value="Normal" style="width: 20px;text-align: left;" [(ngModel)]="neurological" >Normal
  <label>       </label>
  <input type="radio" name="Neur"  value="Abnormal" style="width: 20px;text-align: left;"  [(ngModel)]="neurological">Abnormal
  <label>       </label>
  <label>Specify  </label>
    <input type="text"  name="LolSize" placeholder=" " style="width: 25%;height: 30px;" required   [(ngModel)]="neurspec" >

</div>
<hr>
<br>
<!------********* Lymphadenopathy ***************-->
<div >
  <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;background-color:  gray;color: aliceblue;font-size: 20px;font-style: normal; width: 300px;">Lymphadenopathy                     </label>
  <label>                              </label>
  <input type="radio" name="Lymph" value="Normal" style="width: 20px;text-align: left;"   [(ngModel)]="lymphadenopathy">Normal
  <label>       </label>
  <input type="radio" name="Lymph"  value="Abnormal" style="width: 20px;text-align: left;" [(ngModel)]="lymphadenopathy">Abnormal

</div>
<hr>

<table style="width: 900px;">
  <thead style="background-color: rgb(190, 183, 183);">
      <tr >
          <th style="width: 20%;background-color: rgb(190, 183, 183);color: black;font-weight: bold;text-align: center;">Site</th>
          <th style="width: 15%;background-color: rgb(190, 183, 183);color: black;font-weight: bold;text-align: center;">Level</th>
          <th style="width: 15%;background-color: rgb(190, 183, 183);color: black;font-weight: bold;text-align: center;">Size</th>
          <th style="width: 25%;background-color: rgb(190, 183, 183);color: black;font-weight: bold;text-align: center;">Consistency</th>
          <th style="width: 25%;background-color: rgb(190, 183, 183);color: black;font-weight: bold;text-align: center;">Mobility</th>
      </tr>`
  </thead>
  <tbody>
    <tr>
          <td data-column="Item ID"><label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-size: 18px;font-style: normal; width: 40%;">Right Cervical</label></td>
          <td data-column="Item Name"> <input type="text"  name="Level1" placeholder=" " style="width: 100%;height: 25px;" required  [(ngModel)]="rcervicallevel">          </td>
          <td data-column="Item Name"> <input type="text"  name="Size1" placeholder=" " style="width: 100%;height: 25px;" required  [(ngModel)]="rcervicalsize" >          </td>
          <td data-column="Item Name">
            <input type="radio" name="RCervCons1" value="Soft" style="width: 20px;text-align: left;" [(ngModel)]="rcervicalcons" >Soft
            <input type="radio" name="RCervCons1" value="Firm" style="width: 20px;text-align: left;" [(ngModel)]="rcervicalcons" >Firm
            <input type="radio" name="RCervCons1" value="Hard" style="width: 20px;text-align: left;" [(ngModel)]="rcervicalcons" >Hard
          </td>
            <td data-column="Item Name">
              <input type="radio" name="RCervMob1" value="Fixed" style="width: 20px;text-align: left;"  [(ngModel)]="rcervicalmob">Fixed
              <input type="radio" name="RCervMob1" value="Mobile" style="width: 20px;text-align: left;" [(ngModel)]="rcervicalmob">Mobile
           </td>
      </tr>
      <tr>
        <td data-column="Item ID"><label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-size: 18px;font-style: normal; width: 40%;">Left Cervical</label></td>
        <td data-column="Item Name"> <input type="text"  name="Level2" placeholder=" " style="width: 100%;height: 25px;" required [(ngModel)]="lcervicallevel" >          </td>
        <td data-column="Item Name"> <input type="text"  name="Size2" placeholder=" " style="width: 100%;height: 25px;" required [(ngModel)]="lcervicalsize" >          </td>
        <td data-column="Item Name">
          <input type="radio" name="LCervCons1" value="Soft" style="width: 20px;text-align: left;" [(ngModel)]="lcervicalcons">Soft
          <input type="radio" name="LCervCons1" value="Firm" style="width: 20px;text-align: left;" [(ngModel)]="lcervicalcons">Firm
          <input type="radio" name="LCervCons1" value="Hard" style="width: 20px;text-align: left;" [(ngModel)]="lcervicalcons">Hard
     </td>
        <td data-column="Item Name">
              <input type="radio" name="LCervMob1" value="Fixed" style="width: 20px;text-align: left;" [(ngModel)]="lcervicalmob">Fixed
              <input type="radio" name="LCervMob1" value="Mobile" style="width: 20px;text-align: left;" [(ngModel)]="lcervicalmob">Mobile
          </td>
      </tr>
    <tr>
      <td data-column="Item ID"><label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-size: 18px;font-style: normal; width: 40%;">Right Axillary</label></td>
      <td data-column="Item Name"> <input type="text"  name="Level3" placeholder=" " style="width: 100%;height: 25px;" required  [(ngModel)]="raxillarylevel">          </td>
      <td data-column="Item Name"> <input type="text"  name="Size3" placeholder=" " style="width: 100%;height: 25px;" required  [(ngModel)]="raxillarysize">          </td>
      <td data-column="Item Name">
              <input type="radio" name="RAxiCons1" value="Soft" style="width: 20px;text-align: left;"  [(ngModel)]="raxillarycons">Soft
              <input type="radio" name="RAxiCons1" value="Firm" style="width: 20px;text-align: left;" [(ngModel)]="raxillarycons">Firm
              <input type="radio" name="RAxiCons1" value="Hard" style="width: 20px;text-align: left;" [(ngModel)]="raxillarycons">Hard
      </td>
      <td data-column="Item Name">
              <input type="radio" name="RAxiMob1" value="Fixed" style="width: 20px;text-align: left;"  [(ngModel)]="raxillarymob">Fixed
              <input type="radio" name="RAxiMob1" value="Mobile" style="width: 20px;text-align: left;" [(ngModel)]="raxillarymob" >Mobile
      </td>
  </tr>
  <tr>
    <td data-column="Item ID"><label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-size: 18px;font-style: normal; width: 40%;">Left Axillary</label></td>
    <td data-column="Item Name"> <input type="text"  name="Level4" placeholder=" " style="width: 100%;height: 25px;" required [(ngModel)]="laxillarylevel" >          </td>
    <td data-column="Item Name"> <input type="text"  name="Size4" placeholder=" " style="width: 100%;height: 25px;" required [(ngModel)]="laxillarysize" >          </td>
    <td data-column="Item Name">
      <input type="radio" name="LAxiCons1" value="Soft" style="width: 20px;text-align: left;" [(ngModel)]="laxillarycons">Soft
      <input type="radio" name="LAxiCons1" value="Firm" style="width: 20px;text-align: left;" [(ngModel)]="laxillarycons">Firm
      <input type="radio" name="LAxiCons1" value="Hard" style="width: 20px;text-align: left;" [(ngModel)]="laxillarycons">Hard
    </td>
    <td data-column="Item Name">
      <input type="radio" name="LAxiMob1" value="Fixed" style="width: 20px;text-align: left;" [(ngModel)]="laxillarymob">Fixed
      <input type="radio" name="LAxiMob1" value="Mobile" style="width: 20px;text-align: left;" [(ngModel)]="laxillarymob">Mobile
    </td>
</tr>
<tr>
  <td data-column="Item ID"><label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-size: 18px;font-style: normal; width: 40%;">Right Lnguinal</label></td>
  <td data-column="Item Name"> <input type="text"  name="LolSize" placeholder=" " style="width: 100%;height: 25px;" required  [(ngModel)]="ringuinalsite">          </td>
  <td data-column="Item Name"> <input type="text"  name="LolSize" placeholder=" " style="width: 100%;height: 25px;" required  [(ngModel)]="ringuinalsize" >          </td>
  <td data-column="Item Name">
    <input type="radio" name="RLngCons1" value="Soft" style="width: 20px;text-align: left;" [(ngModel)]="ringuinalcons">Soft
    <input type="radio" name="RLngCons1" value="Firm" style="width: 20px;text-align: left;" [(ngModel)]="ringuinalcons">Firm
    <input type="radio" name="RLngCons1" value="Hard" style="width: 20px;text-align: left;" [(ngModel)]="ringuinalcons">Hard

  </td>
  <td data-column="Item Name">
    <input type="radio" name="RLngMob1" value="Fixed" style="width: 20px;text-align: left;" [(ngModel)]="ringuinalmob">Fixed
    <input type="radio" name="RLngMob1" value="Mobile" style="width: 20px;text-align: left;" [(ngModel)]="ringuinalmob">Mobile
  </td>
</tr>
<tr>
  <td data-column="Item IDDD"> <label for="History1" style="text-align: center;padding-top: 0.5%; height: 45px;font-size: 18px;font-style: normal; width: 40%;">Left Lnguinal</label></td>
  <td data-column="Item Nam1"> <input type="text"  name="LolSize" placeholder=" " style="width: 100%;height: 25px;" required  [(ngModel)]="linguinalsite">          </td>
  <td data-column="Item Nam2"> <input type="text"  name="LolSize" placeholder=" " style="width: 100%;height: 25px;" required  [(ngModel)]="linguinalsize">          </td>
  <td data-column="Item Nam3">
    <input type="radio" name="LLngCons1" value="Soft" style="width: 20px;text-align: left;" [(ngModel)]="linguinalcons">Soft
    <input type="radio" name="LLngCons1" value="Firm" style="width: 20px;text-align: left;" [(ngModel)]="linguinalcons">Firm
    <input type="radio" name="LLngCons1" value="Hard" style="width: 20px;text-align: left;" [(ngModel)]="linguinalcons">Hard

  </td>
  <td data-column="Item Name">
    <input type="radio" name="LLngMob1" value="Fixed" style="width: 20px;text-align: left;" [(ngModel)]="linguinalmob" >Fixed
    <input type="radio" name="LLngMob1" value="Mobile" style="width: 20px;text-align: left;"  [(ngModel)]="linguinalmob">Mobile
  </td>
</tr>
  </tbody>
</table>


<br>
<button type="button" class="theme-button btn" name="submit" (click) = "submitGeneralExamination()" >Submit</button>
<button type="button" class="theme-button btn" name="delete"  >Delete General Examinations</button>

</mat-tab>


  <!----********** Out Side Treatment ******************--->
  <mat-tab label="Treatment Outside Cairo Cure">Treatment Outside Cairo Cure
    <div class="appointment-form-field">
      <label for="History1" style="text-align: center;padding-top: 0.5%; height: 35px;background-color:  gray;color: aliceblue;font-size: larger;font-style: initial; width: 800px;" >Surgery</label>
  </div>
 <table style="font-size: small;width: 800px;">
  <thead>
      <tr>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 15.2%;height: 5%;">Date</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 18%;height: 25%;">Type of Surgery</th>
          <th style="background-color:  rgb(70, 70, 247);color: white; width: 30%;height: 8%;">Comment</th>
          <th style="background-color:  rgb(70, 70, 247);color: white; width: 15%;height: 35px;">Select</th>

      </tr>
  </thead>
  <tbody>

    <tr *ngFor="let cur of sergury; let i = index" style="height: 50%;">
      <td data-column="Patient ID" style="height: 5%;">{{cur.tttdate}}</td>
      <td data-column="Patient Name"style="height: 30%;">{{cur.tttname}}</td>
      <td data-column="Patient Name"style="height: 30%;">{{cur.tttnotes}}</td>
      <button name="BDrug" placeholder = "0" style="width: 100%;height: 35px;" required (click)="SelectOutSide(cur)">Select</button>
    </tr>
  </tbody>
</table>
<div class="styled-input">
    <div class="appointment-form-field">
    <input type="date" name="SurDate" placeholder="0" required="" style="width: 13%;" [(ngModel)]="tttdate" />
    <select id="surtype" name="surtype" required="" style="width: 15.5%;background-color: white;" [(ngModel)]="tttname" [value]="uom">
      <option value="" selected>Select *</option>
      <option value="Palliative">Palliative</option>
      <option value="Radical">Radical</option>
    </select>

      <input type="textarea" name="endoCommint" placeholder="Comments" [(ngModel)]= "tttnotes" required="" style="width: 25%;"/>

      <button name="BDrug" placeholder = "0" style="width: 6.1%;height: 100%;" required (click)="submitOutSideSurgery()">Submit</button>
      <label style="width: .7%;"></label>
      <button name="BDrug1" placeholder = "0" style="width: 6.1%;height: 100%;" required (click)="DelOutSideSurgeryLine()">Delete</button>
    </div>
</div>
<BR>
<div class="appointment-form-field">
  <label for="History1" style="text-align: center;padding-top: 0.5%; height: 35px;background-color:  gray;color: aliceblue;font-size: larger;font-style: initial; width: 1000px;" >Radiotherapy</label>
</div>
<table style="font-size:smaller; width: 1000px;">
<thead>
    <tr>
        <th style="background-color:  rgb(70, 70, 247);color: white;width: 16%;height: 5%;">Date</th>
        <th style="background-color:  rgb(70, 70, 247);color: white;width: 16%;height: 8%;">Site</th>
        <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;height: 8%;">Dose</th>
        <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;height: 8%;">#Fraction</th>
        <th style="background-color:  rgb(70, 70, 247);color: white; width: 16%;height: 8%;">Response</th>
        <th style="background-color:  rgb(70, 70, 247);color: white; width: 16%;height: 8%;">Toxicity</th>

        <th style="background-color:  rgb(70, 70, 247);color: white; width: 11%;height: 8%;">Select</th>

    </tr>
</thead>
<tbody>

  <tr *ngFor="let path of radiotherapy; let i = index" style="height: 50%;font-size: small;">
    <td data-column="Patient ID" style="height: 5%;">{{path.tttdate}}</td>
    <td data-column="Patient Name"style="height: 30%;">{{path.tttname}}</td>
    <td data-column="Patient Name"style="height: 10%;">{{path.tttduration_dose}}</td>
    <td data-column="Patient Name"style="height: 10%;">{{path.tttnumb}}</td>
    <td data-column="Patient Name"style="height: 10%;">{{path.tttresponse}}</td>
    <td data-column="Patient Name"style="height: 10%;">{{path.ttttoxicity}}</td>
    <button name="BDrug" style="width: 100%;height: 35px;" required (click)="SelectOutSideR(path)">Select</button>
  </tr>
</tbody>
</table>
<div class="styled-input">
  <div class="appointment-form-field">
  <input type="date" name="RadioDate" placeholder="0" required="" style="width: 13.8%;" [(ngModel)]= "tttdateR"/>
  <select id="SiteType" name="SiteType" placeholder="Select" required="" style="width: 14%;background-color: white;" [(ngModel)]="tttnameR" [value]="tttnameR">
  <option value="">Select</option>
  <option value="Brain">Brain</option>
  <option value="Breast">Breast</option>
  <option value="Bone">Bone</option>
  <option value="Uterus">Uterus</option>
  <option value="Prostate">Prostate</option>
  <option value="colon">colon</option>
  <option value="arm">arm</option>
  <option value="Whole pelvis irradiation">Whole pelvis irradiation</option>
  <option value="Cervical L.Ns">Cervical L.Ns</option>
  <option value="Brachytherapy HDR">Brachytherapy HDR</option>
  <option value=">NPx">NPx</option>
  <option value="Larynx">Larynx</option>
  <option value="Neck">Neck</option>
  </select>

    <input type="textarea" name="RadioDpse" placeholder="0" [(ngModel)]= "tttduration_doseR" required="" style="width: 8.5%;"/>

    <input type="textarea" name="histype" placeholder="0" [(ngModel)]= "tttnumbR" required="" style="width: 9.5%;"/>
    <select id="radRes" name="RadRes" required="" style="width: 14%;background-color: white;" [(ngModel)]="tttresponseR" [value]="tttresponseR">
      <option value="">Select</option>
      <option value="Disease">Disease progression</option>
      <option value="Disease Stable">Disease Stable</option>
      <option value="Complete Remission">Complete Remission</option>
      <option value="Partial Remission">Partial Remission</option>
      <option value="NK">NK</option>
    </select>


    <input type="textarea" name="Radtoxcicty" placeholder="Toxicty" [(ngModel)]= "ttttoxicityR" required="" style="width: 13.5%;"/>


    <button name="BDrug" placeholder = "0" style="width: 5%;height: 100%;" required (click)="submitOutSideRadio()">Submit</button>
    <button name="BDrug1" placeholder = "0" style="width: 5%;height: 100%;" required (click)="DelOutSideRadioLine()">Delete</button>
  </div>
</div>

<BR>
  <div class="appointment-form-field">
    <label for="History1" style="text-align: center;padding-top: 0.5%; height: 35px;background-color:  gray;color: aliceblue;font-size: larger;font-style: initial; width: 1000px;" >Chemotherapy</label>
  </div>
  <table style="font-size:smaller; width: 1000px;">
  <thead>
      <tr>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 12%;height: 8%;">Date</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 12%;height: 8%;">Date End</th>
          <th style="background-color:  rgb(70, 70, 247);color: white; width: 15%;height: 8%;">Protocol</th>
          <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;height: 8%;">#Cycle</th>
          <th style="background-color:  rgb(70, 70, 247);color: white; width: 12.6%;height: 8%;">Response</th>
          <th style="background-color:  rgb(70, 70, 247);color: white; width: 12.5%;height: 8%;">Toxicity</th>

          <th style="background-color:  rgb(70, 70, 247);color: white; width: 9%;height: 8%;">Select</th>

      </tr>
  </thead>
  <tbody>

    <tr *ngFor="let path of chemotherapy; let i = index" style="height: 50%;font-size: small;">
      <td data-column="Patient ID" style="height: 5%;">{{path.tttdate}}</td>
      <td data-column="Patient Name"style="height: 30%;">{{path.tttenddate}}</td>
      <td data-column="Patient Name"style="height: 10%;">{{path.tttname}}</td>
      <td data-column="Patient Name"style="height: 10%;">{{path.tttnumb}}</td>
      <td data-column="Patient Name"style="height: 10%;">{{path.tttresponse}}</td>
      <td data-column="Patient Name"style="height: 10%;">{{path.ttttoxicity}}</td>
      <button name="BDrug" style="width: 100%;height: 35px;" required (click)="SelectOutSideC(path)">Select</button>
    </tr>
  </tbody>
  </table>
  <div class="styled-input">
    <div class="appointment-form-field">
    <input type="date" name="ChemoDate" placeholder="0" required="" style="width: 12%;" [(ngModel)]= "tttdateC"/>
    <input type="date" name="ChemoEndDate" placeholder="0" required="" style="width: 12%;" [(ngModel)]= "tttenddateC"/>

    <select id="radRes" name="chemoProtocol" required="" style="width: 15%;background-color: white;" [(ngModel)]="tttnameC" [value]="tttnameC">
      <option value="">Select</option>
      <option value="{{img.prHdName}}" *ngFor="let img of protocols; let i = index">{{img.prHdName}}</option>
    </select>

      <input type="textarea" name="chemcycle" placeholder="0" [(ngModel)]= "tttnumbC" required="" style="width: 10%;"/>
      <select id="ChemoRes" name="ChemoRes" required="" style="width: 12.6%;background-color: white;" [(ngModel)]="tttresponseC" [value]="pathinvhtype">
        <option value="">Select</option>
        <option value="Disease">Disease progression</option>
        <option value="Disease Stable">Disease Stable</option>
        <option value="Complete Remission">Complete Remission</option>
        <option value="Partial Remission">Partial Remission</option>
        <option value="NK">NK</option>
      </select>


      <input type="textarea" name="Chemotoxcicty" placeholder="Toxicty" [(ngModel)]= "ttttoxicityC" required="" style="width: 12.5%;"/>


      <button name="BDrug" placeholder = "0" style="width: 4.5%;height: 100%;" required (click)="submitOutSideChemo()">Submit</button>
      <button name="BDrug1" placeholder = "0" style="width: 4.5%;height: 100%;" required (click)="DelOutSideChemoLine()">Delete</button>
    </div>
  </div>

  <BR>
    <div class="appointment-form-field">
      <label for="History1" style="text-align: center;padding-top: 0.5%; height: 35px;background-color:  gray;color: aliceblue;font-size: larger;font-style: initial; width: 1000px;" >Hormonal Therapy</label>
    </div>
    <table style="font-size:smaller; width: 1000px;">
    <thead>
        <tr>
            <th style="background-color:  rgb(70, 70, 247);color: white;width: 15%;height: 8%;">Date</th>
            <th style="background-color:  rgb(70, 70, 247);color: white; width: 25%;height: 16%;">Type</th>
            <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;height: 8%;">Duration</th>
            <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;height: 8%;">Response</th>
            <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;height: 8%;">Toxicity</th>

            <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;height: 8%;">Select</th>

        </tr>
    </thead>
    <tbody>

      <tr *ngFor="let path of hormonal; let i = index" style="height: 50%;font-size: small;">
        <td data-column="Patient ID" style="height: 5%;">{{path.tttdate}}</td>
        <td data-column="Patient Name"style="height: 10%;">{{path.tttname}}</td>
        <td data-column="Patient Name"style="height: 10%;">{{path.tttduration_dose}}</td>
        <td data-column="Patient Name"style="height: 10%;">{{path.tttresponse}}</td>
        <td data-column="Patient Name"style="height: 10%;">{{path.ttttoxicity}}</td>
        <button name="BDrug" style="width: 100%;height: 35px;" required (click)="SelectOutSideH(path)">Select</button>
      </tr>
    </tbody>
    </table>
    <div class="styled-input">
      <div class="appointment-form-field">
      <input type="date" name="horDate"   required="" style="width: 15.5%;" [(ngModel)]= "tttdateH"/>
       <select id="horType" name="horType" required="" style="width: 26%;background-color: white;" [(ngModel)]="tttnameH" [value]="tttnameH">

        <option value="">Select</option>
        <option value="Tamoxifen">Tamoxifen</option>
        <option value="Nolvadex">Nolvadex</option>
        <option value="Aromasine">Aromasine</option>
        <option value="Arimidex">Arimidex</option>
        <option value="Femara">Femara</option>
        <option value="Zoladex">Zoladex 10.8</option>
        <option value="Lupron 11.25">Lupron 11.25</option>
        <option value="Casodex">Casodex</option>
        <option value="Megace 160 mg">Megace 160 mg</option>
        <option value="Zoladex 3.6mg">Zoladex 3.6mg</option>
      </select>

        <input type="textarea" name="horcycle" placeholder="0" [(ngModel)]= "tttduration_doseH" required="" style="width: 10.5%;"/>
        <select id="horRes" name="HorRes" required="" style="width: 10.6%;background-color: white;" [(ngModel)]="tttresponseH" [value]="tttresponseH">
          <option value="">Select</option>
          <option value="Disease">Disease progression</option>
          <option value="Disease Stable">Disease Stable</option>
          <option value="Complete Remission">Complete Remission</option>
          <option value="Partial Remission">Partial Remission</option>
          <option value="NK">NK</option>
        </select>


        <input type="textarea" name="Radtoxcicty" placeholder="Toxicty" [(ngModel)]= "ttttoxicityH" required="" style="width: 10.2%;"/>


        <button name="BDrug" placeholder = "0" style="width: 5.2%;height: 100%;" required (click)="submitOutSideHormonal()">Submit</button>
        <button name="BDrug1" placeholder = "0" style="width: 5.2%;height: 100%;" required (click)="DelOutSideHormonalLine()">Delete</button>
      </div>
    </div>

    <BR>

    <div class="styled-input">
              <label>Disease Status before starting TTT at COC               </label>
              <input type="radio" name="op1" value="CR"  [(ngModel)]= "disname" (change)="submitDisStarting()">CR
              <label>       </label>
              <input type="radio" name="op1"  value="PR" [(ngModel)]= "disname" (change)="submitDisStarting()">PR
              <label>       </label>
              <input type="radio" name="op1" value="SD"  [(ngModel)]= "disname" (change)="submitDisStarting()">SD
              <label>       </label>
              <input type="radio" name="op1"  value="PD"  [(ngModel)]= "disname" (change)="submitDisStarting()">PD
              <label>       </label>
              <input type="radio" name="op1"  value="NK"  [(ngModel)]= "disname" (change)="submitDisStarting()">NK
    </div>


  </mat-tab>

  <!----********** Follow Up / Visits ******************--->
  <mat-tab label="First Visits & Follow Up">Visits or Follow up
    <div class="styled-input">
      <BR>
      <BR>
      <div class="appointment-form-field">
        <input type="number" name="visSerial" min="1"  id="visSerial" (keyup)="retriveFollowUp()" (change)="retriveFollowUp()" [(ngModel)]="visverial"  style="width: 68px;height: 42px;background-color:  rgb(187, 203, 238);" required >
        <label style="width: 40px;">Date</label>

        <span class="fa fa-calendar" style="cursor: grab;width:50px;"   aria-hidden="true"></span>
        <input type="date" name="visitDate"  [(ngModel)]="visdate" required="" style="width: 15%;"/>

        <label>                                                     </label>
          <label style="width: 111px;">Type of Visit</label>
          <span class="fa fa-headphones" style="cursor: grab;width:45px;"   aria-hidden="true"></span>
          <select id="VisType" name="VisType" required  style="width: 22%;" [(ngModel)]="vistype" (change)="checkFirstVisit()"  >
            <option value="">Select</option>
            <option value="First Visit">First Visit</option>
            <option value="Planned Visit">Planned Visit</option>
            <option value="Emergency Visit">Emergency Visit</option>

        </select>

      </div>

        <div class="appointment-form-field">
            <label style="width: 108px;">Doctor</label>
            <!-- <label>       </label> -->
            <span class="fa fa-user-md" aria-hidden="true" style ="width:50px;" ></span>
            <select id="doctor" name="doctor" required="" [(ngModel)]="visdoctor" [value]="docName" style="width: 25%;">
                <option value="{{doc.docCode}}"  *ngFor="let doc of doctorsList; let i = index">{{doc.docName}}</option>
            </select>
            <label>                              </label>
            <label style="width: 100px;">Location</label>
            <!-- <label>      </label> -->
            <span class="fa fa-map-marker" aria-hidden="true"  style ="width:45px;"></span>
            <select id="location" name="location" required="" [(ngModel)]="vislocation" [value]="compName" style="width: 22%;">
                <option value="{{doc.compCode}}"  *ngFor="let doc of companyList; let i = index">{{doc.compName}}</option>
            </select>
        </div>
        <div class="appointment-form-field">
          <label style="width: 108px;">Type of Service</label>
          <!-- <label>       </label> -->
          <span class="fa fa-archive" aria-hidden="true"  style ="width:50px;"></span>
          <select id="service" name="service" required="" [(ngModel)]="visservice" [value]="visservice" style="width: 25%;">
                        <option value="Clinic Visit" selected>Clinic Visit</option>
                        <option value="Radiotherapy">Radiotherapy</option>
                        <option value="Chemotherapy">Chemotherapy</option>
                        <option value="Hospital">Hospital</option>
                        <option value="Others">Others</option>
          </select>

      </div>

      <label style="width: 1000px;height: 30px; padding-top: 0.5%;background-color: cadetblue;text-align: center;font-weight: bold;" *ngIf="!FirstVisit" >Assessment Resume at 1st. Presentation</label>
      <div class="appointment-form-field">
          <label style="width: 108px;">Pa. progress Notes</label>
          <!-- <label>        </label> -->
          <span class="fa fa-university" aria-hidden="true" style="width: 50px;" ></span>
          <textarea rows = "5" cols = "60" name = "diganosis" [(ngModel)]="visdiganosis" class="appointment-form-field" maxlength="250ch" style="width: 70%;"></textarea><br>

      </div>

        <BR>
        <BR>
        <div class="appointment-form-field" *ngIf="!FirstVisit" >
          <label style="width: 75px;">Present History</label>
          <label>       </label>
          <span class="fa fa-heartbeat" aria-hidden="true" style="height: 200%;"></span>
          <textarea rows = "5" cols = "60" name = "investigations" [(ngModel)]="vispresenthistory" class="appointment-form-field" maxlength="250ch" style="width: 70%;height: 200%;">  </textarea><br>

    </div>
        <BR>
          <div class="appointment-form-field">
              <label style="width: 75px;">Complaint</label>
              <label>       </label>
              <span class="fa fa-search" aria-hidden="true"  (click)="DialogComplains()" style="cursor: grab;"></span>
              <textarea rows = "5" cols = "60" name = "complaint" [(ngModel)]="viscomplaint" class="appointment-form-field" maxlength="250ch" style="width: 70%;"></textarea><br>
          </div>
           <BR>
            <!---- ***** Current Medication ********------>
            <div>
            <label style="width: 175px;">Current Medication</label>
            <table style="width: 950px;">
              <thead>
                  <tr>
                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 25%;height: 8%;">Drug</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 20%;height: 8%;">Notes</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 8%;height: 8%;">Dose</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 15%;height: 8%;">Unit</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;height: 8%;">Route</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;height: 8%;">Frequency</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 15%;height: 8%;">Select</th>

                  </tr>
              </thead>
              <tbody>

                <tr *ngFor="let cur of currentmedication; let i = index" style="height: 50%;">
                  <td data-column="Patient ID" style="height: 5%;">{{cur.ittname}}</td>
                  <td data-column="Patient ID" style="height: 5%;">{{cur.duration}}</td>
                  <td data-column="Patient Name"style="height: 30%;">{{cur.dose}}</td>
                  <td data-column="Patient Name"style="height: 10%;">{{cur.unname}}</td>
                  <td data-column="Patient Name"style="height: 10%;">{{cur.route}}</td>
                  <td data-column="Patient Name"style="height: 10%;">{{cur.frequancy}}</td>
                  <button name="BDrug" placeholder = "0" style="width: 100%;height: 35px;" required (click)="SelectCurrent(cur)">Select</button>
                </tr>
              </tbody>
            </table>
            <div class="styled-input">
                <div class="appointment-form-field">
                 <select id="relation" name="relation" style="width: 19.1%;background-color:  rgb(187, 203, 238);" [(ngModel)]= "drugref" required>
                    <option value="{{itm2.itCode}}"  *ngFor="let itm2 of itemsList2; let i = index">{{itm2.itTName}}</option>
                </select>
                <input type="textarea" name="duration" placeholder="notes" [(ngModel)]= "duration" required="" style="width: 15.65%;"/>
                <input type="textarea" name="dos" placeholder="0" [(ngModel)]= "dose" required="" style="width: 6%;"/>
                <select id="department" name="unit" required="" style="width: 11.6%;background-color: white;" [(ngModel)]="uom" [value]="uom">
                  <option value="{{unit.unCode}}" *ngFor="let unit of unitsList; let i = index">{{unit.unName}}</option>
                </select>
                  <input type="textarea" name="Route" placeholder="0" [(ngModel)]= "route" required="" style="width: 7.6%;"/>
                  <input type="textarea" name="Frequency" placeholder="0" [(ngModel)]= "frequancy" required="" style="width: 7.8%;"/>
                  <button name="BDrug" placeholder = "0" style="width: 5.5%;height: 100%;" required (click)="submitCMedication()">Submit</button>
                  <label style="width: .5%;"></label>
                  <button name="BDrug1" placeholder = "0" style="width: 5.5%;height: 100%;" required (click)="delCurrentMedication_Line()">Delete</button>
                </div>
                <button name="prescription" class="theme-button btn fa fa-pencil-square-o" style="width: 19%;height: 100%;"  required (click)="printPrescription()">  Print Prescription</button>

            </div>
            <div class="appointment-form-field">
              <label style="width: 75px;">Drug interaction</label>
              <label>        </label>
              <span class="fa fa-eye" aria-hidden="true"  style="height: 150%;" ></span>
              <textarea rows = "5" cols = "60" name = "didescription" [(ngModel)]="didescription" class="appointment-form-field" maxlength="250ch" style="width: 70%;height: 150%;"></textarea><br>
              <input (change)="picked($event)" type="file" id="photo" name="photo"
              accept="image/*" style="width: 300px;height: 150%;" >
              <label>   </label>
              <img src="data:image/jpg;base64,{{myimage}}" (click) = "openDialogViwer()" alt="User Image" width="200px" style="cursor: zoom-in;border: 1px;border-style: inset;" height="260px;padding-top:65px;" />
            </div>

            </div>
          <BR>
          <BR>
          <div class="appointment-form-field" >
                <label style="width: 75px;">Requested Investigations</label>
                <label>        </label>
                <span class="fa fa-search" aria-hidden="true" style="height: 200%;"></span>
                <textarea rows = "5" cols = "60" name = "reqinvestigations" [(ngModel)]="visreqinvistigation" class="appointment-form-field" maxlength="250ch" style="width: 68.5%;height: 200%;">  </textarea><br>

          </div>

          <BR>
          <BR>
            <div class="appointment-form-field">
              <label style="width: 75px;">Examination      </label>

              <label>         </label>
              <span class="fa fa-balance-scale" style="cursor: grab;"   aria-hidden="true"></span>
              <input type="text" name="weight" [(ngModel)]="visweight" required="" style="width: 10%;" placeholder="Weight"/>
              <label>                 </label>


                <span class="fa fa-heartbeat" style="cursor: grab;"   aria-hidden="true"></span>
                <input type="text" name="bloodP" [(ngModel)]="visbp" required="" style="width: 10%;" placeholder="Blood Pressure"/>
                <label>                 </label>

              <span class="fa fa-stethoscope" style="cursor: grab;"   aria-hidden="true"></span>
              <input type="text" name="pulse" [(ngModel)]="vispuls"  required="" style="width: 10%;" placeholder="Pulse"/>

            </div>
            <BR>
            <BR>
            <div class="appointment-form-field">
                    <label style="width: 9.5%;">                       </label>

                    <span class="fa fa-hospital-o" aria-hidden="true" style="height: 200%;"></span>
                    <textarea rows = "5" cols = "60" name = "exam" [(ngModel)]="visexamination" class="appointment-form-field" placeholder="Examination Details" maxlength="250ch" style="width: 70%;height: 200%;"></textarea><br>

            </div>
            <BR>
              <BR>
              <!-- <div class="appointment-form-field">
                      <label style="width: 9.5%;">                       </label>
                      <button type="button" class="theme-button btn" name="investigation" style="width: 78%;">Investigations</button>


              </div> -->

              <BR>
              <BR>
              <div class="styled-input">
                  <label>Disease Status              </label>
                  <input type="radio" name="chk11" value="CR" required="" [(ngModel)]="visdiseasestatus"/>CR
                  <label>       </label>
                  <input type="radio" name="chk11"  value="PR" required="" [(ngModel)]="visdiseasestatus"/>PR
                  <label>       </label>
                  <input type="radio" name="chk11"  value="SD" required=""[(ngModel)]="visdiseasestatus" />SD
                  <label>       </label>
                  <input type="radio" name="chk11" value="PD" required=""[(ngModel)]="visdiseasestatus" />PD
                  <label>       </label>
                  <input type="radio" name="chk11" value="NK" required=""[(ngModel)]="visdiseasestatus" />NK
              </div>

              <BR>
              <div class="appointment-form-field">
                      <label style = "width: 130px;">Site                 </label>
                      <input type="text" name="site" [(ngModel)]="vissite" style="width: 20%;" required="" />
                      <label>              </label>
                      <label>Stage   </label>

                      <select id="PatientStatus" name="PatientStatus" [(ngModel)]="visstage" style="width: 18%;background-color:  rgb(187, 203, 238);" [(ngModel)]= "stage"  required>
                        <option value="0">Select* </option>
                        <option value="1">Stage I </option>
                        <option value="2">Stage II</option>
                        <option value="3">Stage III</option>
                        <option value="4">Stage IV</option>
                        <option value="5">NK</option>

                    </select>
                    <label>           </label>
                    <label>Grade    </label>

                    <select id="visgrade" name="visgrade" [(ngModel)]="visgrade" style="width: 18%;background-color:  rgb(187, 203, 238);"   required>
                      <option value="0">Select* </option>
                      <option value="1">Grade I </option>
                      <option value="2">Grade II</option>
                      <option value="3">Grade III</option>
                      <option value="5">NK</option>

                  </select>


              </div>
              <BR>
                <div class="appointment-form-field">
                        <label style = "width: 130px;">T                     </label>
                        <select id="vist" name="vist" [(ngModel)]="vist"  style="width: 20%;background-color:  rgb(187, 203, 238);"    required>
                          <option value="">Select* </option>
                          <option value="0">0 </option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="Tx">Tx</option>

                      </select>
                        <label>              </label>
                        <label>N          </label>

                        <select id="visn" name="visn" [(ngModel)]="visn" style="width: 18%;background-color:  rgb(187, 203, 238);"    required>
                          <option value="">Select* </option>
                          <option value="0">0 </option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="Nx">Nx</option>

                      </select>
                      <label>           </label>
                      <label>M           </label>

                      <select id="vism" name="vism" [(ngModel)]="vism" style="width: 18%;background-color:  rgb(187, 203, 238);"   required>
                        <option value="">Select* </option>
                        <option value="0">0 </option>
                        <option value="1">1</option>
                        <option value="Mx">Mx</option>


                    </select>


                </div>
                <BR>
                <div class="styled-input">
                  <label>Status                     </label>
                  <input type="radio" name="chk100"  value="Adjuvant" required="" [(ngModel)]="visstatus"  />Adjuvant
                  <label>       </label>
                  <input type="radio" name="chk100"  value="Locally Advanced" required="" [(ngModel)]="visstatus" />Locally Advanced
                  <label>       </label>
                  <input type="radio" name="chk100"  value="Metastatic" required="" [(ngModel)]="visstatus" />Metastatic
                  <label>       </label>
                  <input type="radio" name="chk100"  value="Unknown" required="" [(ngModel)]="visstatus" />Unknown

              </div>

              <BR>
                <div class="appointment-form-field">
                        <label style="width: 130px;">Decision   </label>

                        <span class="fa fa-search-plus" aria-hidden="true" style="height: 200%;cursor: zoom-in;"  (click)="DialogZoom_Decision()" title="Zoom In"></span>
                        <textarea rows = "5" cols = "60" [(ngModel)]="visdecision"  name = "decision" placeholder="Visit Decision Details" class="appointment-form-field"  style="width: 75%;height: 200%;" ></textarea><br>

                </div>
                <BR>
                <BR> <!--- Treatment Policy ---->
                <!-- <div class="styled-input">
                    <label>Treatment Policy                     </label>
                    <input type="radio" name="op122" value="Surgery"  [(ngModel)]="vistttpolicy" required="" (click)= "checkSurgery()"/>Surgery
                    <label>       </label>
                    <input type="radio" name="op122" value="Radiotherapy" [(ngModel)]="vistttpolicy" required="" (click) ="checkRadio()"/>Radiotherapy
                    <label>       </label>
                    <input type="radio" name="op122" value="Chemptherapy" [(ngModel)]="vistttpolicy" required=""(click) ="checkChemo()" />Chemptherapy
                    <label>       </label>
                    <input type="radio" name="op122" value="Hormonal Therapy" [(ngModel)]="vistttpolicy" required="" (click) ="checkHormonal()"/>Hormonal Therapy
                    <label>       </label>
                    <input type="radio" name="op122" value="Others" [(ngModel)]="vistttpolicy" required="" (click) ="checkOthers()"/>Others

                </div> -->
                <!--- Surgery ---->
                <label style="font-weight: bold ;text-underline-position: below;" class="fa fa-flag-checkered"> Treatment Policy                     </label>
                <div class="appointment-form-field" >
                          <label style="width: 130px;">Surgery      </label>

                          <select id="surgeryType" name="surgeryType" style="width: 20%;background-color:  rgb(187, 203, 238);" [(ngModel)]= "vissurgerytype"  required>
                            <option value="">Select* </option>
                            <option value="Palliative">Palliative</option>
                            <option value="Radical">Radical</option>
                        </select>
                          <label>    </label>
                          <label style="width: 100px;">Notes       </label>

                          <span class="fa fa-check-square-o" aria-hidden="true" ></span>
                          <textarea rows = "5" cols = "60" name = "SurgeryNotes" placeholder="Surgery Details" class="appointment-form-field" [(ngModel)]= "vissurgerynotes" maxlength="250ch" style="width: 45.5%;"></textarea><br>

                </div>
                <!--- Radiotherapy ---->

                <div class="appointment-form-field" >
                            <label style="width: 130px;">Radiotherapy     </label>
                            <select id="radiotherapy" name="radiotherapy" style="width: 20%;background-color:  rgb(187, 203, 238);" [(ngModel)]= "visradiotype"  required>
                              <option value="">Select* </option>
                              <option value="arm">arm</option>
                              <option value="Bone">Bone</option>
                              <option value="Brachytherapy-HDR">Brachytherapy HDR</option>
                              <option value="Brain">Brain</option>
                              <option value="Breast">Breast</option>
                              <option value="Cervical">Cervical L.Ns</option>
                              <option value="colon">colon</option>
                              <option value="Larynx">Larynx</option>
                              <option value="Neck">Neck</option>
                              <option value="NPx ">NPx </option>
                              <option value="Prostate">Prostate</option>
                              <option value="Uterus">Uterus</option>
                              <option value="Whole-pelvis-irradiation">Whole pelvis irradiation</option>

                          </select>
                          <label>    </label>
                            <label style="width: 100px;">Dose        </label>

                            <span class="fa fa-check-square-o" aria-hidden="true" ></span>
                            <input type="text" name="radiodose"  required="" style="width: 7%;"  [(ngModel)]= "visradiodose" />

                            <label>        </label>
                            <label>Notes   </label>

                            <span class="fa fa-check-square-o" aria-hidden="true" ></span>
                            <textarea rows = "5" cols = "60" name = "radiotherapyNots" placeholder="Radiotherapy Details" [(ngModel)]= "visradionotes" class="appointment-form-field" maxlength="250ch" style="width: 26%;"></textarea><br>

                </div>
              <!--- Chemotherapy ---->

              <div class="appointment-form-field">
                            <label style="width: 130px;">Chemotherapy   </label>
                            <select id="Chemotherapy" name="Chemotherapy" placeholder="Select*" [(ngModel)]= "vischemotype" [value]="prHdCode"  style="width: 20%;background-color:  rgb(187, 203, 238);" [(ngModel)]= "stage"  required>
                              <option value="">Select*</option>
                              <option value="{{Canc.prHdCode}}" *ngFor="let Canc of protocolHD; let i = index">{{Canc.prHdName}}</option>

                          </select>
                          <label>    </label>
                            <label style="width: 100px;">Cycle#     </label>

                            <span class="fa fa-check-square-o" aria-hidden="true" ></span>
                            <input type="text" name="cycle"  required="" style="width: 7%;" [(ngModel)]= "vischemocycle"/>

                            <label>        </label>
                            <label  >Notes   </label>

                            <span class="fa fa-check-square-o" aria-hidden="true" ></span>
                            <textarea rows = "5" cols = "60" name = "chemoNots" placeholder="Chemotherapy Details / Timing"  [(ngModel)]= "vischemonotes" class="appointment-form-field" maxlength="250ch" style="width: 26%;"></textarea><br>

              </div>
              <!--- Hormonaltherapy ---->

              <div class="appointment-form-field" >
                            <label style="width: 130px;">Hormonal           </label>
                            <select id="Hormonaltherapy" name="Hormonaltherapy" placeholder="Select*" style="width: 20%;background-color:  rgb(187, 203, 238);" [(ngModel)]= "vishormonaltype"  required>
                              <option value="">Select* </option>
                              <option value="Arimidex">Arimidex </option>
                              <option value="Aromasine">Aromasine</option>
                              <option value="Casodex">Casodex</option>
                              <option value="Estracyte-140-mg">Estracyte 140 mg</option>
                              <option value="Femara">Femara</option>
                              <option value="Lupron-11-25">Lupron 11.25</option>
                              <option value="Megace-160-mg">Megace 160 mg </option>
                              <option value="Nolvadex">Nolvadex</option>
                              <option value="Tamoxifen">Tamoxifen</option>
                              <option value="Zoladex-10-8">Zoladex 10.8 </option>
                              <option value="Zoladex-3-6mg">Zoladex 3.6mg</option>
                              <option value="Others">Others</option>

                          </select>
                          <label>    </label>
                            <label style="width: 100px;">Duration   </label>

                            <span class="fa fa-check-square-o" aria-hidden="true" ></span>
                            <input type="text" name="duration"  required="" style="width: 7%;" [(ngModel)]= "vishormonalduration"/>

                            <label>        </label>
                            <label>Notes   </label>

                            <span class="fa fa-check-square-o" aria-hidden="true" ></span>
                            <textarea rows = "5" cols = "60" name = "hormonalNots" placeholder="Hormonaltherapy Details / Timing"  [(ngModel)]= "vishormonalnotes" class="appointment-form-field" maxlength="250ch" style="width: 26%;"></textarea><br>

              </div>
<!--- Others ---->

<div class="appointment-form-field" >
  <label style="width: 130px;">Others           </label>

  <span class="fa fa-check-square-o" aria-hidden="true" ></span>
  <textarea rows = "5" cols = "60" name = "hormonalNots" placeholder="Analgesic" class="appointment-form-field" [(ngModel)]= "visotherstype" maxlength="250ch" style="width: 75.4%;"></textarea><br>
</div>
                <BR>
                <div class="appointment-form-field">
                          <label style="width: 10.6%;">Next Appointment      </label>

                          <span class="fa fa-search" style="cursor: grab;"   aria-hidden="true"></span>
                          <input type="date" name="visnextdate"   [(ngModel)]="visnextdate" required="" style="width: 15%;"/>
                          <label> </label>
                          <span class="fa fa-edit" aria-hidden="true" ></span>
                          <textarea rows = "5" cols = "60" name = "appointmen"  [(ngModel)]="visnextaction" placeholder="Next Appointment Action" class="appointment-form-field" maxlength="250ch" style="width: 56%;"></textarea><br>

                </div>
      </div>
      <hr>
      <br>
<button type="button" class="theme-button btn" name="submit11" (click) = "submitFollowUp()" >Submit</button>
<button type="button" class="theme-button btn" name="delete11" (click)= "mesgDeleteFollowupvisit()"    >Delete Current Visit</button>

  </mat-tab>

</mat-tab-group>
</form>
</div>
</div>
</div>
  </section>
</div>

